<template>
  <div class="no-shrink preview">
    <div class="flex column center-all">
      <span v-if="!content || (!content.text && !hasAttachment)" style="font-size: 40px;">💬</span>
      <div
        v-else
        class="template-message-wrapper"
        :class="{ document: hasAttachment, buttons: content.buttons && content.buttons.length }" >
        <div
          class="template-message"
          :class="{ buttons: content.buttons && content.buttons.length }">
          <pdf
            v-if="content.attachmentType && content.attachmentType.toLowerCase() === 'document' && exampleUrl"
            class="attachment"
            :class="[content.attachmentType.toLowerCase(), { placeholder: !exampleUrl, 'document-overlay': exampleUrl && content.attachmentType.toLowerCase() === 'document' }]"
            :src="exampleUrl" />
          <div
            v-else-if="hasAttachment"
            class="attachment"
            :class="[content.attachmentType.toLowerCase(), { placeholder: !exampleUrl, 'video-overlay': exampleUrl && content.attachmentType.toLowerCase() === 'video' }]"
            :style="{ 'background-image': `url(${exampleUrl})` }" />

          <!-- No user input is rendered here. -->
          <!-- eslint-disable vue/no-v-html  -->
          <div
            v-if="contentReactive.text"
            class="message-body tag-content"
            v-html="whatsAppFormatToHTML(contentReactive.text)" />
        </div>

        <!-- BUTTONS -->
        <template v-if="content.buttons && contentReactive.buttons.length">
          <div
            v-for="(button, index) in content.buttons"
            :id="`button-${index}`"
            :key="index"
            class="button" >
            <img
              v-if="button.icon"
              :src="/\{\{\d*\}\}$/.test(button.value) ? button.icon.grey : button.icon.dark"
              height="12"
              class="menu-icon mr-2" >
            <span
              v-if="button.title"
              :class="{ waiting: /\{\{\d*\}\}$/.test(button.value) }"
              class="ellipsis" >{{ button.title }}</span>
            <span
              v-else
              class="skeleton" />
            <!-- Only allow copy if the url or phone button -->
            <div
              v-if="['PHONE_NUMBER', 'URL'].includes(button.type) && (button.value || button.title)"
              class="copy-me-wrapper">
              <div
                v-clipboard="button.value ? button.value.replace(/\{\{([^\{\}\d]*?)\}\}$/g, '$1') : button.title"
                class="copy-me"
                @success="copyToClipboard"
                @error="copyToClipboard(false)" />
            </div>
            <b-popover
              v-if="['PHONE_NUMBER', 'URL'].includes(button.type)"
              :target="`button-${index}`"
              boundary="window"
              triggers="hover"
              placement="top"
              :delay="{ show: 50, hide: 0 } "
              custom-class="basic-popover button-popover" >
              <template v-if="button.value">
                {{ button.value.substring(0, 100).replace(/\{\{*[^\{\}]*?\}*\}*$/, '') }}{{ button.value.length > 100 ? '...' : '' }}
                <!-- <span v-if="button.value.endsWith('\{\{1\}\}')" >/</span> -->
                <span
                  v-if="/\{\{\d*\}\}$/.test(button.value)"
                  class="blue"
                  v-html="button.value.replace(/^.*\{\{([^{}]*?)\}\}$/g, '{{$1}}')" />
                <span
                  v-else-if="/\{\{*[^\{\}]*?\}\}$/.test(button.value)"
                  class="blue"
                  v-html="button.value.replace(/^.*\{\{([^{}]*?)\}\}$/g, '$1')" />
              </template>
            </b-popover>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getThumbnails } from 'video-metadata-thumbnails';
import pdf from 'vue-pdf';

import { whatsappFormatMessage, convertToTagView, whatsAppFormatToHTML } from '@/helpers/stringHelpers';
import { getFileExtension, getMediaType, getMediaTypeForLastMessage, allowedTemplateMessageAttachments } from '@/helpers/mediaHelpers';
import ToasterMixin from '@/mixins/Toaster';

export default {
  name: 'MessagePreview',
  components: {
    pdf,
  },
  mixins: [
    ToasterMixin,
  ],
  props: {
    content: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      exampleUrl: '',
    };
  },
  computed: {
    hasAttachment() {
      return this.content.attachmentType;
    },
    contentReactive() {
      return this.content;
    },
  },
  watch: {
    content: {
      handler: function f() {
        this.getAttachmentUrl();
      },
      deep: true,
      // immediate: true,
    },
  },
  methods: {
    whatsAppFormatToHTML,
    copyToClipboard(success = true) {
      if (success) {
        this.showToaster('Copied to clipboard.', null, null, 'OK');
      }
    },
    getAttachmentUrl() {
      if (this.content.attachment) {
        const mediaType = this.content.attachment.type ? getMediaType(this.content.attachment.type) : getMediaType(getFileExtension(this.content.attachment.name));
        if (mediaType === 'video') {
          this.parseVideoThumbnails(this.content.attachment);
          return;
        }
        if (mediaType === 'document') {}

        const URLObj = window.URL || window.webkitURL;
        this.exampleUrl = this.content.attachment.name.startsWith('http') ? this.content.attachment.name : URLObj.createObjectURL(this.content.attachment);
      } else {
        this.exampleUrl = '';
      }
    },
    async parseVideoThumbnails(videoBlob) {
      const thumbnails = await getThumbnails(videoBlob, {
        quality: 0.6,
        start: 0,
        end: 0,
        scale: 0.5,
      });
      const URLObj = window.URL || window.webkitURL;
      this.exampleUrl = URLObj.createObjectURL(thumbnails[0].blob);
    },
  },
};
</script>

<style lang="scss" scoped>
.preview {
  width: 325px;
  // height: 100%;
  // overflow-y: auto;
  padding: 20px;
  background: $white;
  border-left: 1px solid #E6EBED;

  & > div {
    min-height: 100%;
  }
}

.template-message-wrapper {
  width: fit-content;
  max-width: 288px;

  &.document, &.buttons {
    width: 100%;
  }

  .template-message {
    border-radius: 19px;
    overflow: hidden;
    border: 2px solid $bluePrimary;

    .attachment {
      background-color: #f0f6fe;
      height: 95px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      overflow: hidden;

      &.placeholder::after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background-image: unset !important;
        background-color: #65a5f1 !important;
        mask: url(~@/assets/img/SB-Icons/doc-new.svg) no-repeat center !important;
        mask-size: 26px 26px !important;
      }

      &.image::after {
        mask: url(~@/assets/img/SB-Icons/image-placeholder.svg) no-repeat center !important;
        mask-size: 26px 26px !important;
      }

      &.video::after {
        mask: url(~@/assets/img/SB-Icons/video-placeholder.svg) no-repeat center !important;
        mask-size: 26px 26px !important;
      }

      &.video.video-overlay::after {
        mask: unset !important;
        mask-size: unset !important;
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background-image: url('~@/assets/img/video-overlay.svg');
        background-size: 52px;
        background-repeat: no-repeat;
        background-position: center;
        background-color: rgba(red($blackPrimary), green($blackPrimary), blue($blackPrimary), 0.3);
        opacity: 1;
      }

      &.document.document-overlay::before {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background: linear-gradient(215deg, rgba(20,28,32,0.75) 0%, rgba(255,255,255,0) 18%);
        opacity: 1;
        position: absolute;
        top: 0;
      }
      &.document.document-overlay::after {
        mask-image: url('~@/assets/img/SB-Icons/download-arrow.svg') !important;
        mask-size: 16px 16px !important;
        content: '';
        display: block;
        width: 20px;
        height: 20px;
        background-color: $white !important;
        mask-repeat: no-repeat;
        mask-position: center;
        opacity: 1;
        position: absolute;
        top: 5px;
        right: 5px;
      }
    }

    // .show-play-overlay

    .message-body {
      background-color: $bluePrimary;
      padding: 5px 12px;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.37;
      color: $white;

      ::v-deep .template-tag, ::v-deep .editor-tag,
      ::v-deep .template-tag, ::v-deep span code {
        color: $white !important;
        border: 1px solid $white !important;
        background-color: #4190ed !important;
        margin-right: 1px;
        line-height: 1.2;
        font-size: 12px !important;
        font-weight: 500 !important;
        padding: 0 7px !important;
        border-radius: 9px !important;
        margin-right: 0;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Ubuntu, sans-serif !important;
      }
    }

    &.buttons {
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
    }

    ::v-deep {
      p {
        min-height: 10px;
      }
    }
  }

  &.document .template-message .message-body {
    padding: 7px 11px;
  }

  .button {
    margin-top: 3px;
    border: 1px solid #b1cff2;
    border-radius: 3px !important;
    color: $bluePrimary;
    background-color: $white;
    width: 100%;
    box-shadow: none;
    justify-content: center;
    overflow: hidden;
    cursor: default;
    position: relative;
    min-height: 32.8px;
    display: inline-flex;
    align-items: center;
    padding: 7px 10px;
    font-size: 14px;
    font-weight: 500;

    .skeleton {
      background-color: $greyBorderModal !important;
      height: 12px;
      width: 50%;
      border-radius: 100px;
    }

    .sb-icon {
      margin-right: 4px;
    }

    .copy-me-wrapper {
      position: absolute;
      opacity: 0;
      right: 5px;
      width: 30px;
      height: 20px;
      background: rgb(255,255,255);
      background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 43%, rgba(255,255,255,1) 100%);

      .copy-me {
        position: absolute;
        right: 0;
        cursor: pointer;
        margin: 4px 0 4px;
        display: block;
        width: 20px;
        height: 12px;
        background-image: url('~@/assets/img/SB-Icons/copy.svg');
        background-repeat: no-repeat;
        background-position: center;

        &:hover {
          background-image: url('~@/assets/img/SB-Icons/copy-hover.svg');
        }
      }
    }

    &:last-of-type {
      border-bottom-left-radius: 19px !important;
      border-bottom-right-radius: 19px !important;
    }

    &:hover .copy-me-wrapper {
      opacity: 1;
    }

    .waiting {
      color: #7C8B91;
    }
  }
}

#attachment-wrapper {
  ::v-deep .error {
    padding: 0 !important;
  }
}
</style>

<style lang="scss">
  .button-popover {
    max-width: 450px;

    .popover-body {
      display: inline-flex;
      .blue {
        color: $bluePrimary !important;
        font-weight: 500;
      }
    }
  }
</style>
